import { Container } from './SpinnerWithCheck.styles';

export enum SpinnerMode {
  LOADING = 'loading',
  SUCCESS = 'success',
  NOT_STARTED = 'not_started',
}

export default function SpinnerWithCheck({ mode = SpinnerMode.NOT_STARTED }: { mode?: SpinnerMode } = {}) {
  return (
    <Container>
      <svg
        className={`sr-spinner ${mode}`}
        viewBox="0 0 52 52"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g stroke-width="4">
          <circle
            className="rotating"
            fill="none"
            cx="26"
            cy="26"
            r="22"
            stroke-linecap="round"
            stroke-dasharray="200"
          />
          <path fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" stroke-dasharray="100" />
        </g>
      </svg>
    </Container>
  );
}
